import { render, staticRenderFns } from "./ResumeBox.vue?vue&type=template&id=5852fd86&"
import script from "./ResumeBox.vue?vue&type=script&lang=js&"
export * from "./ResumeBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports